module.exports = __webpack_public_path__ + "static/media/image (7).59f54540.jpg";